import styled from 'styled-components'
import {
  Box, Button,
  IcoMoon,
  Text,
  TextInput,
} from '@usap/uicomponents'
import { Heading1 } from '../heading'

export const CouponsFormMainContainer = styled(Box)`
  width: ${({ isCart }) => (isCart ? '500px' : '100%')}
`

export const CouponsFormInnerContainer = styled(Box)`
  width: 310px;
  margin-bottom: 16px;
  ${({ theme }) => theme.mediaQuery.down('tablet-landscape')} {
    width: 100%;
  }
`

export const BrandLogo = styled(IcoMoon)`
  height: 100%;
  width: 100%;
`

export const CouponsHeaderContainer = styled(Box)`
  margin: 8px 0;
`

export const CouponsFormHeading = styled(Heading1)`
  font-size: 38px;
  font-weight: 400;
  line-height: 38px;
  ${({ theme }) => theme.mediaQuery.down('tablet-landscape')} {
    font-size: 24px;
    line-height: normal;
  }
`

export const InfoMessageText = styled(Text)`
  margin: 8px 0;
  ${({ theme }) => theme.mediaQuery.down('tablet-landscape')} {
    margin-top: 16px;
    margin-bottom: 0;
  }
`

export const CouponsFormContainer = styled(Box)`
  margin-top: 8px;
  line-height: 62px;
  border: 1px solid rgb(224, 224, 224);
  ${({ theme }) => theme.mediaQuery.down('tablet-landscape')} {
    margin-top: 24px;
  }
`

export const CouponsFormLogoContainer = styled(Box)`
  width: 10%;
  ${({ theme }) => theme.mediaQuery.down('tablet-landscape')} {
    width: 20%;
  }
`

export const CouponsFormTextInput = styled(TextInput)`
  font-size: 16px;
  padding: 0;
  font-weight: normal;
  text-align: center;
  ${({ theme }) => theme.mediaQuery.down('tablet-landscape')} {
    font-size: 14px;
    padding: 0 20% 0 0;
  }
`

export const CouponsFormButtonContainer = styled(Box)`
  width: 520px;
  padding: 24px 0;
  ${({ theme }) => theme.mediaQuery.down('tablet-landscape')} {
    width: 100%;
    padding: 16px 0;
  }
`

export const CouponsFormButton = styled(Button)`
  height: 62px;
  line-height: 62px;
  padding: 0 16px;
  text-align: center;
`

export const CouponsFormTextButton = styled(Text)`
  font-size: 30px;
  line-height: 62px;
  ${({ theme }) => theme.mediaQuery.down('tablet-landscape')} {
    font-size: 24px;
  }
`
